import client from '../client';

export interface UploadSlipRequest {
  reference_id: string;
  file: File;
}

export interface UploadSlipResponse {
  success: boolean;
  message: string;
  slip_url?: string;
}

export default function API(request: UploadSlipRequest): Promise<UploadSlipResponse> {
  const formData = new FormData();
  formData.append('reference_id', request.reference_id);
  formData.append('file-0', request.file);

  return client
    .put(`payment_v2/transaction/update-slip`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => response.data);
}
